import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme';

const EmptyState = ({ icon, title, description, action }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      py: 8,
      px: 3,
      gap: 1.5,
    }}
  >
    {icon && (
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: tokens.radius.lg,
          backgroundColor: tokens.color.surface.subtle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: tokens.color.ink.muted,
          mb: 0.5,
          '& .MuiSvgIcon-root': { fontSize: 28 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="h5" sx={{ color: tokens.color.ink.primary }}>
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        sx={{ color: tokens.color.ink.muted, maxWidth: 360, lineHeight: 1.6 }}
      >
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 1 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
